"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CARBON_GAS_PRICE = exports.DEFAULT_FEE = exports.PAGINATE_10K = exports.DEFAULT_GAS = exports.DEFAULT_GAS_PRICE = exports.DEFAULT_FEE_DENOM = void 0;
const pagination_1 = require("../codec/cosmos/base/query/v1beta1/pagination");
const proto_signing_1 = require("@cosmjs/proto-signing");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const long_1 = __importDefault(require("long"));
exports.DEFAULT_FEE_DENOM = "swth";
// 0.0000001 SWTH
exports.DEFAULT_GAS_PRICE = new bignumber_js_1.default(10);
exports.DEFAULT_GAS = new bignumber_js_1.default(100000000);
exports.PAGINATE_10K = pagination_1.PageRequest.fromPartial({ limit: new long_1.default(10000) });
exports.DEFAULT_FEE = {
    amount: (0, proto_signing_1.coins)(exports.DEFAULT_GAS_PRICE.times(exports.DEFAULT_GAS).dp(0).toString(), "swth"),
    gas: exports.DEFAULT_GAS.toString(10),
};
exports.CARBON_GAS_PRICE = {
    low: 1,
    average: 1.5,
    high: 2,
};
